export const calculateAge = (birthdate: string): number => {
  const birth = new Date(birthdate);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  
  return age;
};

export const validateAge = (birthdate: string, minAge: number = 16, maxAge: number = 120): { isValid: boolean; age: number } => {
  const age = calculateAge(birthdate);
  return {
    isValid: age >= minAge && age <= maxAge,
    age
  };
};